export const knowledgeBaseZh = {
  title: "知识库",
  subtitle: "企业知识搜索与问答",
  searchPlaceholder: "搜索文档、文章、政策...",
  searchButton: "搜索",
  resultsTitle: "搜索结果",
  fileResultsTitle: "文件结果",
  folderResultsTitle: "文件夹结果",
  resultCount: "共 {count} 条结果",
  emptyState: "暂无结果，请尝试其他关键词",
  emptyStateHint: "尝试不同的关键词或检查拼写",
  openInSharePoint: "在 SharePoint 打开",
  open: "查看",
  preview: "预览",
  previewTitle: "内容预览",
  previewSubtitle: "已为你定位到可预览内容",
  previewLoading: "正在加载预览内容...",
  previewFailed: "预览加载失败，请稍后重试",
  previewNoContent: "当前结果暂无可展示的文本内容",
  previewDocumentExcerptHint:
    "当前展示的是检索可用内容摘要；点击“查看”可打开完整原文。",
  previewMetaSource: "来源",
  previewMetaLength: "长度",
  previewSourceType: {
    article: "文章正文",
    documentAggregated: "检索分片聚合",
    documentSnippet: "检索摘要回退",
  },
  previewEmbedFallback:
    "内嵌预览不可用，已回退为文本预览。你仍可点击“查看”打开原文。",
  previewHint: "预览用于快速浏览内容，点击“查看”可打开原文。",
  lastModified: "最后更新",
  fileType: "文件类型",
  createdBy: "创建人",
  loading: "搜索中...",
  clear: "清除",
  relevance: "相关度",
  suggestions: {
    loading: "正在加载建议...",
    empty: "暂无建议",
    clearRecent: "清空",
    removeOne: "删除该搜索词",
    clearFailed: "清空最近搜索失败",
    removeFailed: "删除最近搜索失败",
    group: {
      RECENT_SEARCH: "最近搜索",
      TOP_QUERY: "热门搜索",
      TITLE: "文档与文章",
    },
  },

  // 搜索模式
  searchType: {
    hybrid: "混合搜索",
    keyword: "关键词",
    semantic: "语义搜索",
  },

  // 文档类型
  docType: {
    POLICY: "政策制度",
    MANUAL: "操作手册",
    TUTORIAL: "教程",
    FAQ: "常见问题",
    GENERAL: "一般文档",
    ARTICLE: "知识文章",
    document: "文档",
    article: "文章",
  },

  // 权威等级
  authorityLevel: {
    OFFICIAL: "官方",
    EXPERT: "专家",
    PUBLISHED: "已发布",
    DRAFT: "草稿",
  },

  // 首页
  home: {
    greeting: {
      morning: "早上好",
      afternoon: "下午好",
      evening: "晚上好",
    },
    create: "创建",
    chat: "对话",
    pickUpWhereYouLeftOff: "继续上次浏览",
    defaultCategory: "IT 运维",
    editedAt: "更新于 {time}",
    recently: "最近",
    placeholders: [
      { title: "入门指南", time: "2 小时前" },
      { title: "公司政策", time: "5 小时前" },
      { title: "IT 支持 FAQ", time: "1 天前" },
      { title: "入职清单", time: "2 天前" },
      { title: "福利概览", time: "3 天前" },
      { title: "差旅指南", time: "1 周前" },
    ],
    recentlyVisited: "最近访问",
    recent: "最近",
    starred: "收藏",
    searchArticles: "搜索文章",
    createArticle: "创建文章",
    noRecentArticles: "暂无最近访问的文章",
    quickStart: {
      title: "快速开始",
      items: [
        {
          id: "gettingStarted",
          title: "Getting Started",
          href: "https://faradayandfuture.sharepoint.com/:w:/g/UP2U%20Subcommitee/IQBVROVmse3hSJm5jD8RvuTRAbcEP5AjabbQMgzlQ68Q2Jc?e=0ShGQV",
        },
        {
          id: "howTo",
          title: "How to",
          href: "https://faradayandfuture.sharepoint.com/:w:/g/UP2U%20Subcommitee/IQCLpP7pGqICSLF7i-r8VvMZAfSzmeLzA_9rCvgOIQTJ3Ug?e=T1AiO6",
        },
        {
          id: "faq",
          title: "FAQ",
          href: "https://faradayandfuture.sharepoint.com/:w:/g/UP2U%20Subcommitee/IQAlO1v8VYkrSJQBqe66InPkAce-YZ90gnn9eKDynz6bmAo?e=EmhJaD",
        },
      ],
    },
  },
  articleDetail: {
    title: "文章详情",
    subtitle: "查看站内文章内容",
    back: "返回知识库",
    loading: "加载文章内容...",
    loadFailed: "文章加载失败，请稍后重试",
    status: {
      DRAFT: "草稿",
      PUBLISHED: "已发布",
      ARCHIVED: "已归档",
    },
    fields: {
      status: "状态",
      lastUpdated: "最后更新",
    },
  },
  rebuildIndex: {
    action: "重建索引",
    confirmTitle: "确认重建索引？",
    confirmDescription: "将触发全量索引重建，可能需要一定时间完成。",
    success: "重建任务已触发",
    failed: "重建索引失败，请稍后重试",
  },
  fullSync: {
    action: "全量同步",
    confirmTitle: "确认全量同步？",
    confirmDescription: "将从 SharePoint 拉取全部文档并更新本地索引。",
    success: "全量同步任务已触发",
    failed: "全量同步失败，请稍后重试",
    viewDetails: "查看详情",
  },
  deltaSync: {
    action: "增量同步",
    confirmTitle: "确认增量同步？",
    confirmDescription:
      "将同步 SharePoint 发生变更的文件，必要时自动回退为全量同步。",
    success: "增量同步任务已触发",
    failed: "增量同步失败，请稍后重试",
    viewDetails: "查看详情",
    strategyHint: "增量优先；游标缺失/失效时自动切换为全量同步。",
  },
  syncTaskDetail: {
    title: "同步任务详情",
    subtitle: "查看同步任务状态与统计",
    back: "返回同步记录",
    refresh: "刷新",
    viewSkipped: "查看跳过明细",
    viewProcessed: "查看已处理明细",
    viewProcessing: "查看处理中明细",
    viewFailed: "查看失败明细",
    loading: "正在获取任务状态...",
    loadFailed: "获取任务状态失败",
    taskNotFound: "未找到同步任务",
    overviewTitle: "任务概览",
    overviewDescription: "展示任务执行状态与统计数据",
    fields: {
      taskId: "任务 ID",
      status: "状态",
      totalItems: "总数",
      processedItems: "已处理",
      processingItems: "处理中",
      failedItems: "失败",
      skippedItems: "跳过",
      processedTokens: "处理 Tokens",
      processedChunks: "处理 Chunks",
      error: "错误信息",
      lastChecked: "最近刷新",
    },
    status: {
      PENDING: "待处理",
      SYNCING: "同步中",
      COMPLETED: "已完成",
      FAILED: "失败",
    },
  },
  syncTaskList: {
    entry: "同步记录",
    title: "同步记录",
    subtitle: "查看最近同步记录",
    back: "返回知识库",
    refresh: "刷新",
    loading: "正在获取任务列表...",
    loadFailed: "获取任务列表失败",
    empty: "暂无同步任务",
    overviewTitle: "任务列表",
    totalLabel: "共 {count} 条任务",
    lastChecked: "最近刷新 {time}",
    table: {
      taskId: "任务 ID",
      status: "状态",
      triggerSource: "触发方式",
      total: "总数",
      processed: "已处理",
      processing: "处理中",
      failed: "失败",
      skipped: "跳过",
      tokens: "Tokens",
      chunks: "Chunks",
      createdAt: "创建时间",
      action: "操作",
      view: "查看详情",
      terminate: "终止",
    },
    triggerSource: {
      MANUAL_FULL: "手动全量",
      MANUAL_DELTA: "手动增量",
      DELTA_FALLBACK: "增量回退全量",
      SCHEDULED_FULL: "定时全量",
      UNKNOWN: "未知",
    },
    status: {
      PENDING: "待处理",
      SYNCING: "同步中",
      COMPLETED: "已完成",
      FAILED: "失败",
    },
    terminateConfirmTitle: "终止同步任务？",
    terminateConfirmDescription:
      "将立即终止任务 {taskId}，该任务将标记为失败。",
    terminateConfirmAction: "确认终止",
    terminateSuccess: "同步任务已终止",
    terminateFailed: "终止同步任务失败",
  },
  syncTaskSkipped: {
    title: "跳过明细",
    subtitle: "查看同步跳过的文件与原因",
    back: "返回任务详情",
    refresh: "刷新",
    loading: "正在获取跳过明细...",
    loadFailed: "获取跳过明细失败",
    empty: "暂无跳过记录",
    taskNotFound: "未找到同步任务",
    overviewTitle: "跳过列表",
    totalLabel: "共 {count} 条记录",
    lastChecked: "最近刷新 {time}",
    table: {
      sourceType: "来源",
      filename: "文件名",
      fileExtension: "扩展名",
      mimeType: "MIME 类型",
      reason: "跳过原因",
      createdAt: "记录时间",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "文章",
    },
  },
  syncTaskProcessed: {
    title: "已处理明细",
    subtitle: "查看同步已处理的文件",
    back: "返回任务详情",
    refresh: "刷新",
    loading: "正在获取已处理明细...",
    loadFailed: "获取已处理明细失败",
    empty: "暂无已处理记录",
    taskNotFound: "未找到同步任务",
    overviewTitle: "已处理列表",
    totalLabel: "共 {count} 条记录",
    lastChecked: "最近刷新 {time}",
    table: {
      sourceType: "来源",
      filename: "文件名",
      fileExtension: "扩展名",
      mimeType: "MIME 类型",
      ragflowId: "RAGFlow 文档 ID",
      size: "文件大小",
      tokenCount: "Tokens",
      chunkCount: "Chunks",
      createdAt: "记录时间",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "文章",
    },
  },
  syncTaskProcessing: {
    title: "处理中明细",
    subtitle: "查看同步处理中条目",
    back: "返回任务详情",
    refresh: "刷新",
    loading: "正在获取处理中明细...",
    loadFailed: "获取处理中明细失败",
    empty: "暂无处理中记录",
    taskNotFound: "未找到同步任务",
    overviewTitle: "处理中列表",
    totalLabel: "共 {count} 条记录",
    lastChecked: "最近刷新 {time}",
    table: {
      sourceType: "来源",
      filename: "文件名",
      fileExtension: "扩展名",
      mimeType: "MIME 类型",
      ragflowId: "RAGFlow 文档 ID",
      size: "文件大小",
      tokenCount: "Tokens",
      chunkCount: "Chunks",
      createdAt: "记录时间",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "文章",
    },
  },
  syncTaskFailed: {
    title: "失败明细",
    subtitle: "查看同步失败的文件与原因",
    back: "返回任务详情",
    refresh: "刷新",
    loading: "正在获取失败明细...",
    loadFailed: "获取失败明细失败",
    empty: "暂无失败记录",
    taskNotFound: "未找到同步任务",
    overviewTitle: "失败列表",
    totalLabel: "共 {count} 条记录",
    lastChecked: "最近刷新 {time}",
    table: {
      sourceType: "来源",
      filename: "文件名",
      fileExtension: "扩展名",
      mimeType: "MIME 类型",
      error: "错误信息",
      createdAt: "记录时间",
    },
    sourceType: {
      SP_DOCUMENT: "SharePoint",
      ARTICLE: "文章",
    },
  },

  // 统计面板
  analytics: {
    title: "数据统计",
    viewAll: "查看全部",
    contentOverview: "内容概览",
    projectOverview: "项目概览",
    createdArticles: "创建的文章",
    draft: "草稿",
    published: "已发布",
    views: "浏览量",
    reads: "阅读量",
    likes: "点赞",
    dislikes: "点踩",
    brokenLinks: "失效链接",
    note: "提示：此统计为所有贡献者的汇总数据。",
    timeRange: {
      lastWeek: "最近一周",
      lastMonth: "最近一月",
      allTime: "全部时间",
    },
  },

  // 活动动态
  activity: {
    title: "动态",
    all: "全部",
    mentions: "提及我的",
    comments: "文章评论",
    noActivity: "暂无动态",
    unreadCount: "{count} 条未读",
    lastUpdated: "最后更新：{time}",
    description: {
      mention: "提及了你",
      comment: "评论了文章",
      like: "赞了你的文章",
    },
  },

  // AI 问答
  ask: {
    title: "AI 智能问答",
    subtitle: "基于企业知识库，为您提供准确、可追溯的答案",
    placeholder: "请输入您的问题，例如：公司的报销流程是什么？",
    submit: "提问",
    backToKnowledgeBase: "返回知识库",
    semanticSearchTitle: "智能搜索",
    confidence: "置信度",
    responseTime: "响应时间",
    model: "模型",
    helpful: "这个回答有帮助吗？",
    sources: "参考来源",
    feedbackSuccess: "感谢您的反馈！",
    feedbackFailed: "反馈提交失败",
    askFailed: "问答服务暂时不可用，请稍后再试",
    questionRequired: "请输入您的问题",
  },
  chatbot: {
    ariaLabel: "AI 对话",
    title: "AI 助手",
    emptyTitle: "知识库助手",
    emptyDescription: "可以咨询公司政策、流程或文档相关问题。",
    inputPlaceholder: "请输入问题...",
    scoreLabel: "相关度 {score}%",
  },
  recentlyVisited: {
    editedAt: "编辑于 {time}",
    departmentFallback: "IT 运维",
  },
  upload: {
    title: "上传到知识库",
    subtitle: "文件将上传至 SharePoint 默认文档库",
    button: "上传文件",
    success: "上传成功",
    failed: "上传失败，请稍后重试",
    validation: {
      required: "请选择要上传的文件",
    },
  },
  editor: {
    entry: "新建文章",
    title: "知识库文章编辑",
    subtitle: "单人编辑模式（保存到数据库）",
    save: "保存",
    saving: "保存中...",
    created: "文章已创建",
    saved: "文章已保存",
    saveFailed: "保存失败，请稍后重试",
    articleId: "文章ID：{id}",
    validation: {
      titleRequired: "请输入标题",
      contentRequired: "请输入正文内容",
    },
    fields: {
      title: "标题",
      content: "正文",
      titlePlaceholder: "请输入文章标题",
      contentPlaceholder: "输入“/”快速插入内容",
    },
    commands: {
      heading1: "标题 1",
      heading2: "标题 2",
      heading3: "标题 3",
      callout: "Callout",
      bulletList: "无序列表",
      orderedList: "有序列表",
    },
    layout: {
      breadcrumbRoot: "AI-Workspace",
      breadcrumbSection: "产品研发",
      share: "分享",
      lastEdited: "最近修改：{time}",
      draftTitle: "未命名文档",
      addIcon: "添加图标",
      addCover: "添加封面",
      authorName: "Chentao Jia",
      sampleDate: "2025年12月23日修改",
      outlineTitle: "目录",
      outlineEmpty: "使用 # 创建标题，目录将自动生成",
      insertCallout: "插入 Callout",
      bulletList: "列表",
      orderedList: "编号",
      comment: "评",
      modified: "修改",
    },
  },
  outline: {
    entry: "Outline 编辑器",
    title: "Outline 编辑器（试运行）",
    subtitle: "嵌入式访问 Outline，用于内部知识库试运行",
    embedHint: "若被浏览器阻止嵌入，请点击右侧按钮在新标签打开。",
    open: "在新标签打开",
    missingUrl: "未配置 Outline 地址，请设置 NEXT_PUBLIC_OUTLINE_URL。",
    iframeTitle: "Outline 编辑器",
  },
  validation: {
    queryRequired: "请输入搜索关键词",
  },
  time: {
    justNow: "刚刚",
    minutesAgo: "{count} 分钟前",
    hoursAgo: "{count} 小时前",
    daysAgo: "{count} 天前",
    yesterday: "昨天",
    recently: "最近",
  },
  errors: {
    searchFailed: "搜索失败，请稍后重试",
    searchProviderUnavailable: "检索服务不可用",
    searchProviderUnavailableDescription:
      "请联系管理员检查向量模型授权或余额配置。",
  },
  placeholders: {
    articles: [
      { title: "上手指南", time: "2 小时前" },
      { title: "公司制度", time: "5 小时前" },
      { title: "IT 支持 FAQ", time: "1 天前" },
      { title: "入职清单", time: "2 天前" },
      { title: "福利概览", time: "3 天前" },
      { title: "差旅指引", time: "1 周前" },
    ],
  },
};
